/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { FutureMarket, FutureMarketInterface } from '../FutureMarket'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_controller',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_reader',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_usdc',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_vaultNFT',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'liquidator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeAmount',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingFeePerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'deltaUsdcPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'liquidationPenalty',
        type: 'uint256'
      }
    ],
    name: 'Liquidated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'marginAmount',
        type: 'int256'
      }
    ],
    name: 'MarginUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeAmount',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingFeePerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'deltaUsdcPosition',
        type: 'int256'
      }
    ],
    name: 'PositionUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'mintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'futureVaultCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getLPTokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'liquidationCall',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'onERC721Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'poolPosition',
    outputs: [
      {
        internalType: 'int256',
        name: 'positionAmount',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: 'entryPrice',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: 'entryFundingFee',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: 'usdcAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rebalance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_currentRangeId',
        type: 'uint256'
      }
    ],
    name: 'setCurrentRangeId',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256'
      },
      {
        internalType: 'int24',
        name: '_lowerTick',
        type: 'int24'
      },
      {
        internalType: 'int24',
        name: '_upperTick',
        type: 'int24'
      }
    ],
    name: 'setRange',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'subVaultId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_amount',
        type: 'int256'
      },
      {
        internalType: 'bool',
        name: '_quoterMode',
        type: 'bool'
      }
    ],
    name: 'trade',
    outputs: [
      {
        internalType: 'uint256',
        name: 'traderVaultId',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_marginAmount',
        type: 'int256'
      }
    ],
    name: 'updateMargin',
    outputs: [
      {
        internalType: 'uint256',
        name: 'traderVaultId',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'vaultId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: 'burnAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class FutureMarket__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _controller: string,
    _reader: string,
    _usdc: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FutureMarket> {
    return super.deploy(
      _controller,
      _reader,
      _usdc,
      _vaultNFT,
      overrides || {}
    ) as Promise<FutureMarket>
  }
  getDeployTransaction(
    _controller: string,
    _reader: string,
    _usdc: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controller,
      _reader,
      _usdc,
      _vaultNFT,
      overrides || {}
    )
  }
  attach(address: string): FutureMarket {
    return super.attach(address) as FutureMarket
  }
  connect(signer: Signer): FutureMarket__factory {
    return super.connect(signer) as FutureMarket__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): FutureMarketInterface {
    return new utils.Interface(_abi) as FutureMarketInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FutureMarket {
    return new Contract(address, _abi, signerOrProvider) as FutureMarket
  }
}
